// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

import './assets/less/common.less'

// 请求
import depot from '@/utils/http'
depot()

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.config.ignoredElements = [...Vue.config.ignoredElements, 'wx-open-launch-weapp']

// import Vconsole from 'vconsole'
// var vConsole = new Vconsole();


// 统一提示
const tipMap = {
    1: "success",
    2: "warning",
    3: "info",
    4: "error",
}

window.VueTips = Vue.prototype.$tip = function (title, type, duration, customClass) {
    if (window.tipsModel) {
        window.tipsModel.close()
        window.tipsModel = null;
    }
    let tips = Vue.prototype.$message({
        message: title || '',
        type: tipMap[type] || type || 'success',
        duration: duration || 3000,
        customClass: customClass || ''
    });
    window.tipsModel = tips
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js